// Generated by CoffeeScript 2.7.0
import Admin__TagGroupsController from './tags_group.js';

import Admin__TagsController from './taggables.js';

Skylark.App.Controllers.register({Admin__TagGroupsController, Admin__TagsController});
